'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    period: {
      display: 'flex',
      padding: '0 36px',
      alignItems: 'center',
      marginBottom: 8
    },
    periodItem: {
      flex: '0 0 auto'
    },
    periodIcon: {
      color: theme.calendar.periodIconColor,
      '&:hover': {
        color: theme.calendar.periodIconHoverColor,
        cursor: 'pointer'
      },
      '& .disabled': {
        color: theme.calendar.periodIconDisabledColor,
        opacity: 1,
        '&:hover': {
          cursor: 'default',
          color: theme.calendar.periodIconDisabledColor
        }
      }
    },
    prevMonthIcon: {
      marginRight: 12
    },
    prevYearIcon: {
      marginRight: 8
    },
    nextMonthIcon: {
      marginLeft: 12,
      transform: 'rotate(180deg)'
    },
    nextYearIcon: {
      marginLeft: 8,
      transform: 'rotate(180deg)'
    },
    monthYear: {
      flexGrow: 1,
      flexShrink: 1,
      textAlign: 'center',
      padding: '10px 0 11px 0',
      color: theme.calendar.textColor
    },
    small: {
      '&$period': {
        padding: '0 16px',
        marginBottom: 12
      },
      '& $prevMonthIcon': {
        marginRight: 8
      },
      '& $nextMonthIcon': {
        marginLeft: 8
      },
      '& $monthYear': {
        padding: '3px 0 4px 0'
      }
    }
  };
};